// extracted by mini-css-extract-plugin
export default {"dynamicFormContainer":"Form_dynamicFormContainer__4Y0rk","dynamicFormButton":"Form_dynamicFormButton__XOvvv"};